// This function parses the query string into a dictionary and works across all browsers.
// New browsers support URLSearchParams interface, but IE doesn't support it.
// See https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams for details.
export const parseQueryString = () => {
    const queryStringValues = {};
    const search = window.location.search;
    if (search) {
        const items = search.substring(1).split('&');
        for (let i = 0; i < items.length; i++) {
            var item = items[i].trim();
            // If the query string value is a base-64 encoded string, it may contain trailing equal sign "=".
            // So string.split() function doesn't work well. Find the first index of "=" instead.
            var separatorIndex = item.indexOf('=');
            if (separatorIndex > -1) {
                var key = item.substring(0, separatorIndex);
                var value = item.substring(separatorIndex + 1, item.length);
                queryStringValues[key] = value;
            }
        }
    }
    return queryStringValues;
};

// This function parses the document cookie string into a dictionary.
export const parseCookie = () => {
    const cookieValues = {};
    var items = document.cookie.split(';');
    for (let i = 0; i < items.length; i++) {
        var item = items[i].trim();
        // If the cookie value is a base-64 encoded string, it may contain trailing equal sign "=".
        // So string.split() function doesn't work well. Find the first index of "=" instead.
        var separatorIndex = item.indexOf('=');
        if (separatorIndex > -1) {
            var key = item.substring(0, separatorIndex);
            var value = item.substring(separatorIndex +  1, item.length);
            cookieValues[key] = value;
        }
    }
    return cookieValues;
};


// WEBPACK FOOTER //
// ./src/utils/commonUtils.js